import React, { useState } from "react";
import Input from "../../../../common/components/Forms/Input/Input";
import Icon from "../../../../common/components/Icon/Icon";
import { IClientSettingsBoxProduct } from "../ClientSettingsBox/ClientSettingsBox";
import { useFormikContext } from "formik";
import LifeCalculatorModal from "../../Modals/LifeCalculatorModal/LifeCalculatorModal";
import ProductType from "../../../../common/interfaces/enums/ProductType";
import { ILifeQuoteClient } from "../../../interfaces/form/life/ILifeQuoteClient";
import useSettingsValidation from "../../../hooks/useSettingsValidation";

const ClientSettingsBoxLife: React.FC<IClientSettingsBoxProduct> = (props) => {
    // Prop Destructuring
    const { client, name } = props;
    const { handleBlur } = useFormikContext();
    const { getFormikError } = useSettingsValidation();

    // State Controls
    const [isOpenLifeCalculatorModal, setIsOpenLifeCalculatorModal] = useState(false);

    const handleClickLifeCalculator = (): void => {
        setIsOpenLifeCalculatorModal(true);
    };

    const setClient = <T extends keyof ILifeQuoteClient>(
        key: T,
        value: ILifeQuoteClient[T]
    ): void => {
        props.setClient({
            ...client,
            [ProductType.Life]: {
                ...client[ProductType.Life],
                [key]: value
            }
        });
    };

    return (
        <React.Fragment>
            <LifeCalculatorModal
                isOpen={isOpenLifeCalculatorModal}
                onClose={(coverAmount?: number) => {
                    setIsOpenLifeCalculatorModal(false);
                    if (coverAmount && coverAmount > 0) {
                        setClient("coverAmount", coverAmount);
                    }
                }}
            />

            <Input
                name={`${name}.${ProductType.Life}.coverAmount`}
                label={`Cover amount`}
                type={`number`}
                value={client[ProductType.Life]?.coverAmount}
                hasCurrency
                onBlur={handleBlur}
                className="gap-m"
                onChange={(e) => setClient("coverAmount", e)}
                hasError={getFormikError(`${name}.${ProductType.Life}.coverAmount`)}>
                <p className="text-font-size-s gap-pre-s">
                    <Icon
                        id="Calculator"
                        size="xl"
                        className="calculator-icon-position"
                    />
                    Not sure?&nbsp;
                    <a onClick={handleClickLifeCalculator}>Use our calculator</a>
                </p>
            </Input>
        </React.Fragment>
    );
};

export default ClientSettingsBoxLife;
